import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../services/localization.service';
import { FeatureType, FeatureTypeTranslations } from 'src/app/core/interfaces/feature-type.interface';

@Pipe({ name: 'featureType', pure: false })
export class FeatureTypePipe implements PipeTransform {
    constructor(private localizationService: LocalizationService) { }

    transform(value: FeatureType | string): string {
        if (!value) return '';
        return this.localizationService.getCachedLanguage() === 'ar'
            ? FeatureTypeTranslations[value as FeatureType] || value
            : value;
    }
}